// @flow

import type {Node, StatelessFunctionalComponent} from 'react';

import styled from '@emotion/styled';

import {Base} from 'components/Layout/components/Base';

export const LoadingPage: StatelessFunctionalComponent<{
  children: Node,
}> = styled(Base)`
  display: grid;
  align-content: space-between;
  height: 100vh;
`;
